import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const requestSaveVideoStopTime = (videoId, stoppedTime) => {
  // @ts-ignore
  return authorizedFetch({
    path: '/api/v1/creator_studio/courses/track_video_attachment',
    method: REST_METHODS.POST,
    body: {
      video_id: videoId,
      time: stoppedTime,
    },
  });
};

export default requestSaveVideoStopTime;
